import React from 'react';
import * as S from './styles';

interface NavbarTitleProps {
	children: React.ReactNode;
}

const NavbarTitle = ({ children }: NavbarTitleProps) => {
	return <S.Base>{children}</S.Base>;
};

export default NavbarTitle;
